module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid19_800x793.9668d0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid19_800x793.jpg
// module id = Z9OJ
// module chunks = 0